import React from 'react';


import {
  PuritySelectorContainer,
  PuritySelectorOption
} from './MaterialsLUXE-styled';

interface Props {
  selectedPurity:'9ct'|'14ct'|'18ct'|'500'|'600'|'925'|'950',
  purityOptions:('9ct'|'14ct'|'18ct'|'500'|'600'|'925'|'950')[],
  changePurity:(value:string)=>void
}

export class PuritySelector extends React.Component<Props,{}> {
  constructor(props) {
    super(props)
  }

  public render = () => {
    const { selectedPurity, purityOptions, changePurity } = this.props;

    return (
      <PuritySelectorContainer>
        {purityOptions.map((purityOption) => {
          return (
            <PuritySelectorOption
              key={purityOption}
              isSelected={selectedPurity === purityOption}
              onClick={() => { changePurity(purityOption) }}
            >
              {purityOption}
            </PuritySelectorOption>
          )
        })}


      </PuritySelectorContainer>
    )
  }
}